// extracted by mini-css-extract-plugin
module.exports = {"institution":"index_institution__qUNUf","institution__container":"index_institution__container__2cnli"};